import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import EncoderWheel from '../assets/equipment/3.21-typical-encoder-wheel-line.png';
import SkidDetect from '../assets/equipment/3.22-skid-detect-proximity-sensor.png';
import Photoeye from '../assets/equipment/3.23-part-detect-photoeye.png';
import { BsPencil } from 'react-icons/bs';
import PDPDrawing from '../../../../components/Tables/Tabledata/Drawings/IE-2470-110.pdf';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const WarrenAssemblies = () => {
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);

	const [activeKey, setActiveKey] = useState('Encoder Wheel Line Trackers');
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment</Breadcrumb.Item>
							<Breadcrumb.Item active>Part / Skid Detect</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs activeKey={activeKey} onSelect={setActiveKey} className="mb-3 equipment-element">
								<Tab eventKey="Encoder Wheel Line Trackers" title="Encoder Wheel Line Trackers">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<div class="d-flex">
												<h2>ENCODER WHEEL LINE TRACKERS</h2>{' '}
												<a href={PDPDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<p>The Encoder Wheel Line Tracker units, located at the entrance and exit of the SMARTInspect unit, track the vehicle's position through the inspection and repair cells. In the inspection area, the wheel trackers communicate to the trigger board that reads the encoder counts and determine the position of a vehicle in the cell so that the cameras take their images at the correct positions.</p>

											<p>Every 4mm, the SMARTInspect unit will flash the lights and take the photos.</p>
										</div>

										<div class="right-side">
											<figure style={{ width: '32vw', margin: '20px' }}>
												<img src={EncoderWheel} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: Typical Encoder Wheel Line Tracker</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="AB Skid Detect Switch Bracket" title="AB Skid Detect Switch">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<div class="d-flex">
												<h2>AB SKID DETECT SWITCH</h2>{' '}
												<a href={PDPDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<p>
												The AB Skid Detect Switch is an inductive proximity sensor mounted on the channel strut on side of conveyor. It sends a signal to the <b>PLC</b> once it detects the presence of the part carrier skid on the conveyor.
											</p>
										</div>

										<div class="right-side">
											<figure style={{ width: '30vw', margin: '20px' }}>
												<img src={SkidDetect} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: Skid Detect Proximity Sensor Examples</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Part Detect Photoeye Assembly" title="Part Detect Photoeye Assembly">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<div class="d-flex">
												<h2>PART DETECT PHOTOEYE ASSEMBLY</h2>{' '}
												<a href={PDPDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<p>
												This photoelectric sensor emits a light beam towards the center of the conveyor at a predetermined location. When a vehicle approaches, the beam is reflected back to its receiver and sends a signal to the <b>PLC</b> that a part is present.
											</p>
										</div>

										<div class="right-side">
											<figure style={{ width: '36vw', margin: '20px' }}>
												<img src={Photoeye} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: Part Detect Photoeye</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								{/* <Tab eventKey="Door Open Laser Assembly" title="Door Open Laser Assembly">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>DOOR OPEN LASER ASSEMBLY</h2>
											<p>
												This Retroreflective Laser Sensor emits a light beam to a reflective target and is returned to the sensor’s receiver. If an object, in this case the vehicle door, breaks the beam, it sends a signal to the <b>PLC</b> which stops the conveyor immediately and causes a faulted condition.
											</p>

											<div class="caution">
												<p>Never stare directly into the sensor lens.</p>
												<p>Laser light can damage your eyes.</p>
												<p>Avoid placing any mirror-like object in the beam. Never use a mirror as a retroreflective target.</p>
											</div>
										</div>

										<div class="right-side">
											<figure>
												<img src={DoorLaser} alt="Master Key Box" style={{ width: '36vw', margin: '20px' }} />
												<figcaption>Figure 1: Door Open Laser Assembly</figcaption>
											</figure>
										</div>
									</div>
								</Tab> */}
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default WarrenAssemblies;
